import { Luci_Shopping_Api_Models_InvoiceDetailModel } from './api/v7.1/models/Luci_Shopping_Api_Models_InvoiceDetailModel';

type TaxStrategyType = Luci_Shopping_Api_Models_InvoiceDetailModel.taxStrategy;

export const DEFAULT_TAX_STRATEGY =
  Luci_Shopping_Api_Models_InvoiceDetailModel.taxStrategy.CHARGE_TAX;

export default TaxStrategyType;
